import React, { useState, useEffect, useRef } from 'react';
import { publicUrl, basename } from '../tenant'
import { cardIdFromPostPath, hasNoteIdParam } from '../post-path'
import { useLocation, useNavigate } from 'react-router-dom';
import CONFIG from '../config';

import Container from '../components/Container'
import Nav from '../components/Nav';
import Loading from '../components/Loading'

import '../style.css'
import 'github-markdown-css'
import 'antd/dist/reset.css';

import { getHeptabaseData, getClearCard, heptaToMD, getSiteConfig, ensureCardContents, onSiteDataChange } from '../constantFunction'
import { resolveHomeCard } from '../site-home'
import StatusView from '../components/StatusView'

import { message } from 'antd';

import { installCopyAttribution } from '../copy-attribution';
import { cardShareData, updateShareMeta } from '../share-meta';

// Discord 聊天窗只在配置了 server/channel 且用户点开时才渲染：按需加载，不进首屏包
const WidgetBot = React.lazy(() => import('@widgetbot/react-embed'))

// 属性
let ACTIVE_NOTE = ''                                            // 焦点笔记 ID 例如 38d9247c-1b0b-47ca-a119-933af80d71c2
let CURRENT_URL = window.location.href                          // 当前 URL，用来判断 URL 有变化时触发相关事件
let windowWidth = window.innerWidth                             // 窗口宽度
let minWidth = 600                                              // 以此宽度为分界线需渲染不同界面
// 数据
let HEPTABASE_DATA                                              // hepta 数据
let HOME_DATA                                                   // 首页数据

// 文章页面
function Post(props) {
    const [cardList, setCardList] = useState([]);
    const [activeNote, setActiveNote] = useState('null');
    const [showChatWindow, setShowChatWindow] = useState(false);
    // 状态页：null | 'emptySite'（没有已发布卡）| 'cardMissing'（URL 里的卡都显示不了）| 'loadError'
    const [status, setStatus] = useState(null);
    // 本实例的数据是否已就位（首个 effect 不能用上一个实例遗留的模块级旧数据去跳首页）
    const readyRef = useRef(false)
    // 访客是否「落地在首页」且还没点开别的卡：后台换首页后切回标签页要跟着换
    const landedOnHomeRef = useRef(false)
    // 渲染序号：等正文期间 URL 又变了，只让最新一次生效
    const renderSeqRef = useRef(0)

    let location = useLocation();
    let navigate = useNavigate();

    // console.log('location.search');
    // console.log(location.search);

    useEffect(() => {
        console.log('Post useEffect');

        // 在此，你可以通过创建一个 URLSearchParams 对象来获取查询参数
        // 渲染 URL、数据
        if (readyRef.current) {
            renderFromUrl()
        }

        // handleHashChange(window.location.href, props['card'])

        // 在此可以处理查询参数 myQueryParam 的变化
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);


    useEffect(() => {
        // 划线选中正文后 ⌘C：剪贴板自动追加作者 / 链接 / 来源 / 著作权声明（知乎式）
        const uninstallCopy = installCopyAttribution()

        // 请求 hepta 数据 getHeptabaseData
        getHeptabaseData().then((res) => {
            adoptData(res)
            readyRef.current = true
            // 渲染 URL、数据
            renderFromUrl()
        }).catch(error => {
            console.error('Error:', error);
            // 站点不存在 / 未开放
            if (error && error.status === 404) navigate('/404', { replace: true, state: { missing: true } })
            else setStatus('loadError')
        });

        // 已打开的页面：切回前台时数据层重验目录，有变化推过来（站点设置 / 发布 / 改名即时生效）
        const unsubscribe = onSiteDataChange((event) => {
            if (event.type === 'missing') {
                navigate('/404', { replace: true, state: { missing: true } })
                return
            }
            const oldHomeId = HOME_DATA && HOME_DATA.id
            adoptData(event.data)
            readyRef.current = true
            if (landedOnHomeRef.current && HOME_DATA && HOME_DATA.id !== oldHomeId) {
                // 从首页进来、还没点开别的卡：后台换了首页就跟着换
                navigate('/post?note-id=' + HOME_DATA.id, { replace: true })
            }
            renderFromUrl()
        })

        return () => {
            unsubscribe()
            uninstallCopy()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleShowChatWindow = () => {

        setShowChatWindow(!showChatWindow)

    }

    // 根据 card id 获取 card content
    const findContent = (id, heptabase_blog_data) => {
        if (!heptabase_blog_data || heptabase_blog_data === '') {
            return
        }

        let new_card
        console.log('Post findContent for:');
        for (let i = 0; i < heptabase_blog_data.cards.length; i++) {

            if (heptabase_blog_data.cards[i]['id'] === id) {

                // 正文还没拉到（按需加载失败 / 卡片刚被撤回）：按不存在处理，别让渲染器 JSON.parse(null)
                if (heptabase_blog_data.cards[i]['content'] == null) {
                    return undefined
                }

                // // 处理内容中的图片
                // heptabase_blog_data.cards[i] = getClearImag(heptabase_blog_data.cards[i])

                // 处理反向链接
                new_card = getClearCard(heptabase_blog_data.cards[i], heptabase_blog_data.cards)
                // heptabase_blog_data.cards[i] = new_card['card']

                new_card['card']['content'] = heptaToMD(new_card['card'])

                return new_card

            }
        }

        return new_card

    }

    // 文章内链接、反向链接点击
    const handleLinkClick = (link_id, current_id = undefined, type = -1) => {
        console.log('post.js handleLinkClick');
        let bingo = false
        cardList.forEach(item => {

            if (link_id === item['card']['id']) {

                // 界面上已显示点击的卡片
                bingo = true

            }

        });

        // 已经显示此卡片则不更新 URL 和数据
        if (bingo || current_id === undefined || current_id === null) {


            if (ACTIVE_NOTE !== link_id) {

                // 修改 URL 中的焦点卡片
                setUrlActiveNote(link_id)

                // 记录焦点卡片
                ACTIVE_NOTE = link_id

                // 如果是小尺寸设备，需要更新 UI 显示焦点卡片
                if (windowWidth < minWidth) {

                    // setState({
                    //     activeNote: ACTIVE_NOTE
                    // })

                    setActiveNote(ACTIVE_NOTE)

                }

            }

            ScrollToActiveNote()

            return

        } else {

            // 打开新卡片

            landedOnHomeRef.current = false
            // 先确保目标卡片正文就位（按需拉取），再判断卡片是否存在
            ensureCardContents([link_id]).then(() => {
            let target_card = findContent(link_id, HEPTABASE_DATA)
            if (target_card === undefined) {
                // 卡片无效（不存在 / 未公开 / 正文拉取失败）
                message.info('卡片不存在或未公开');

            } else {
                let getUrlSearch_req = getUrlSearch(window.location.search)
                let url_search_list = getUrlSearch_req['url_search_list']

                let new_url_search = ''
                let current_page_index = -1
                for (let i = 0; i < url_search_list.length; i++) {

                    if (url_search_list[i] === '') {
                        continue
                    }

                    if (url_search_list[i] === current_id) {
                        // URL 参数 === current_id
                        current_page_index = i
                    } else {
                        // URL 参数 !== current_id
                    }

                    if (new_url_search === '') {
                        new_url_search += '?note-id=' + url_search_list[i]
                    } else {
                        new_url_search += '&note-id=' + url_search_list[i]
                    }

                    //如果当前 id === current_id，则忽略后面的所有 ID
                    if (current_page_index > -1) {
                        break;
                    }
                }

                if (new_url_search === '') {
                    new_url_search += '?note-id=' + link_id
                } else {
                    new_url_search += '&note-id=' + link_id
                }


                new_url_search += '&active-note-id=' + link_id

                // 设置 URL
                // window.history.pushState({}, '', window.location.origin + '/post' + new_url_search)
                navigate('/post' + new_url_search)

                // 记录 URL
                CURRENT_URL = publicUrl('/post' + new_url_search)

                // 删除 URL 中不存在的 Card
                resetCardList()
                // 根据 URL 获取 card 数据
                herfToData()
            }
            })

        }

    }

    // 数据就位：记下最新数据，首页每次都从最新数据重新解析（不再沿用旧值 / config 里写死的卡片）
    const adoptData = (res) => {
        HEPTABASE_DATA = res.data
        HOME_DATA = resolveHomeCard(res.data.cards, res.site)
    }

    // URL 规范化（同步）：旧链接 /post/<id> 改写成 ?note-id=；无查询串 = 首页。返回 false 表示空站（没有任何已发布卡）
    const normalizeUrl = () => {
        // 旧链接 /post/<id>（单站时代分享地址、正文内链的 path 形态）：改写成文章页认的 ?note-id=
        // 不改写的话查询串为空，会被下面当成首页直接跳走
        const pathCardId = cardIdFromPostPath(window.location.pathname, basename())
        if (pathCardId && !hasNoteIdParam(window.location.search)) {
            if (HEPTABASE_DATA && HEPTABASE_DATA.cards.some((c) => c.id === pathCardId)) {
                navigate('/post?note-id=' + pathCardId, { replace: true })
            } else {
                // 卡片不存在或未发布：提示后回首页
                message.info('卡片不存在或未公开')
                navigate('/post', { replace: true })
            }
        }

        // 首页的情况
        if (window.location.search === '') {
            if (!HOME_DATA) return false
            navigate('/post?note-id=' + HOME_DATA.id, { replace: true })
            landedOnHomeRef.current = true
        }
        return true
    }

    // 按当前 URL 渲染：规范化 → 确保要显示的卡片正文就位（按需拉取）→ 同步渲染
    const renderFromUrl = () => {
        if (!HEPTABASE_DATA) return Promise.resolve()
        if (!normalizeUrl()) {
            setCardList([])
            setStatus('emptySite')
            return Promise.resolve()
        }
        const seq = ++renderSeqRef.current
        const ids = getUrlSearch(window.location.search)['url_search_list'].filter((id) => id !== '')
        return ensureCardContents(ids).then(() => {
            if (seq !== renderSeqRef.current) return
            herfToData()
        })
    }

    // 根据 herf 渲染界面上显示的数据（同步；正文需已就位，见 renderFromUrl）
    const herfToData = () => {

        if (!normalizeUrl()) {
            setCardList([])
            setStatus('emptySite')
            return
        }

        // 从 URL 中获取 note id，根据 id 获取卡片数据；不存在 / 正文没拿到的卡片跳过
        let card_list = []
        let getUrlSearch_req = getUrlSearch(window.location.search)
        let url_search_list = getUrlSearch_req['url_search_list']

        for (let i = 0; i < url_search_list.length; i++) {
            if (url_search_list[i] === '') {
                continue
            }
            const found = findContent(url_search_list[i], HEPTABASE_DATA)
            if (found) card_list.push(found)
        }

        // URL 里的卡片一张都显示不了（ID 无效 / 已撤回）：显示状态页，不再崩在下面的取值上
        if (card_list.length === 0) {
            setCardList([])
            setStatus('cardMissing')
            return
        }
        setStatus(null)

        // 设置当前活跃的笔记（用户焦点）
        let activeNote
        if (getUrlSearch_req['active_str'] !== '') {
            activeNote = getUrlSearch_req['active_str'].replace('active-note-id=', '')
        } else {
            activeNote = card_list[card_list.length - 1]['card']['id']
        }

        // 根据 URL 渲染新的数据到界面上
        if (cardList !== card_list) {
            setCardList(card_list);
        }


        // 如果焦点发生变化
        if (ACTIVE_NOTE !== activeNote) {
            ACTIVE_NOTE = activeNote
            // 将最新的焦点设置到 URL 中
            setUrlActiveNote(ACTIVE_NOTE)
        }

    }

    // 当 URL 变化时（子组件 container 载入完毕后也会调用此方法）
    const handleHashChange = (url, cardId) => {

        // 如果 url 发生变化，则更新数据
        let old_url = getUrlSearch(CURRENT_URL)
        let new_url = getUrlSearch(url)
        console.log('new_url:');
        console.log(new_url);
        let old_url_1 = old_url['url_search_list'].join('-')
        let new_url_1 = new_url['url_search_list'].join('-')

        // 移除所有小标题
        const url_search_list = new_url.url_search_list
        if (url_search_list.length < 3) {
            // 移除小标题
            const noteTitles = document.querySelectorAll('.note_title');
            noteTitles.forEach(function (title) {
                title.remove();
            });
            // 选取所有同时具有 ".container" 类和 "mini" 类的元素
            const containersWithMini = document.querySelectorAll('.container.mini');
            // 遍历这些元素并移除 "mini" 类
            containersWithMini.forEach(function (container) {
                container.classList.remove('mini');
            });

        }

        // 定位到焦点卡片
        if (new_url['active_str'].indexOf(cardId) > -1) {

            // 定位到焦点卡片
            ScrollToActiveNote()

        }

        // 数据发生变化（忽略焦点变化）
        console.log('new_url_1 !== old_url_1:');
        console.log(new_url_1 !== old_url_1);
        if (new_url_1 !== old_url_1) {

            // 将当前 URL 保存到 state 中
            CURRENT_URL = url

            if (CURRENT_URL !== '') {

                herfToData()

            }
        }

        // 焦点发生变化
        if (old_url['active_str'] !== new_url['active_str']) {

            // 将当前 URL 保存到 state 中
            CURRENT_URL = url

            if (CURRENT_URL !== '') {
                // 记录新焦点到 state 中
                ACTIVE_NOTE = new_url['active_str'].replace('active-note-id=', '')

                // 如果是小尺寸设备，需要更新 UI 显示焦点卡片
                if (windowWidth < minWidth && activeNote !== ACTIVE_NOTE) {

                    // setState({
                    //     activeNote: ACTIVE_NOTE
                    // })

                    setActiveNote(ACTIVE_NOTE)

                }

            }

        }

        // 删除 URL 中不存在的 Card
        resetCardList()

        // 设置卡片样式、小标题
        setCardMiniTitleAndStyle()

        // 增加分享按钮
        // addShareBtn()



    }



    // 删除 URL 中不存在的 Card
    const resetCardList = () => {
        let url = window.location.href
        //比对 url 和 cardList
        for (let i = 0; i < cardList.length; i++) {
            // url 中不存在此 card
            if (url.indexOf(cardList[i]['card']['id']) < 0) {

                // 删除 card
                cardList.splice(i, 1)
                setCardList(cardList)

            } else {
                // url 中存在此 card
                // continue
            }

        }

    }

    // 定位到焦点卡片
    const ScrollToActiveNote = () => {

        let note_list = document.getElementsByClassName('container')
        for (let j = 0; j < note_list.length; j++) {
            let note = note_list[j]
            // 定位到当前用户关注的笔记
            if (note.getAttribute('note_id') === ACTIVE_NOTE) {

                if (windowWidth > minWidth) {
                    document.getElementsByClassName('notes')[0].scrollTo({ left: j * 650, behavior: 'smooth' })


                } else {

                    // 如果是点击头部的页面（Projects、Posts 等）则需要定位到页面顶部
                    let bingo = false

                    if (sessionStorage.getItem('nav_type') > -1 || bingo) {
                        // 滚动到顶部
                        window.scrollTo(0, 0)

                        // 重置 nav_type
                        sessionStorage.setItem('nav_type', -1)
                    }


                }

                break;

            }

        }

    }

    // 设置小标题、overlay 样式
    const setCardMiniTitleAndStyle = () => {
        console.log('setCardMiniTitleAndStyle');
        let notes = document.getElementsByClassName('container')

        for (let j = 0; j < notes.length; j++) {

            // 小标题

            let type = 0 // 记录标题在左侧还是右侧
            let note // 记录需要添加标题的节点

            // 判断卡片的位置，当遮挡前 1 个卡片时，前 1 个卡片显示垂直标题
            let left_mark = notes[j].getBoundingClientRect().x <= j * 40
            // 判断是否要显示右侧标题
            const chatWindowWidth = showChatWindow ? 480 : 0
            let right_mark = notes[j].getBoundingClientRect().x + 1 >= window.innerWidth - chatWindowWidth - (notes.length - j) * 40

            // 左侧小标题
            if (right_mark !== true) {

                if (left_mark) {

                    if (j !== 0) {
                        type = 1
                        note = notes[j - 1]
                    }

                } else {

                    // 移除小标题
                    if (j !== 0) {
                        note = notes[j - 1]
                    }

                    if (note !== undefined) {
                        let note_title = note.getElementsByClassName('note_title')[0]
                        if (note_title !== undefined) {

                            // 移除标题父级容器的类名标记
                            note.classList.remove('mini')

                            // 移除前一个元素的垂直标题
                            note.removeChild(note_title)
                        }
                    }

                }

            }


            // 右侧小标题
            if (left_mark !== true) {

                if (right_mark) {

                    type = 2
                    note = notes[j]
                    // 添加悬浮样式
                    // note.classList.add('overlay')

                } else {
                    // 移除小标题
                    note = notes[j]

                    if (note !== undefined && j !== 0) {
                        let note_title = note.getElementsByClassName('note_title')[0]
                        if (note_title !== undefined) {

                            // 移除标题父级容器的类名标记
                            note.classList.remove('mini')

                            // 移除前一个元素的垂直标题
                            note.removeChild(note_title)
                        }
                    }

                    // 移除悬浮样式
                    // note.classList.remove('overlay')
                }

            }


            // 需要显示小标题
            if (type > 0) {

                // 如果元素无标题
                if (note.classList.contains('mini') === false) {
                    // 前一个元素显示垂直标题
                    let note_title = document.createElement('div')
                    note_title.classList.add('note_title')


                    if (type === 1) {
                        // 左侧小标题
                        note_title.style.left = (j - 1) * 40 + 'px'
                    } else {
                        // 右侧小标题
                        const chatWindowWidth = showChatWindow ? 460 : 0
                        note_title.style.right = (notes.length - j) * 40 - 40 + chatWindowWidth + 'px'
                        note_title.classList.add('overlay')
                    }

                    // 小标题文案
                    let note_title_span = document.createElement('p')

                    if (note.getElementsByTagName('H1').length === 0) {
                        // 如果笔记中没有 H1 标题
                        note_title_span.innerHTML = note.innerText.substring(0, 6) + '...'
                    } else {
                        note_title_span.innerHTML = note.getElementsByTagName('H1')[0].innerHTML
                    }

                    note_title_span.onclick = (event) => {
                        console.log(event);
                        console.log(event.target.innerText);
                        console.log(note.getAttribute('note_id'));
                        handleLinkClick(note.getAttribute('note_id'), undefined, 0)
                    }

                    // 小标题关闭按钮
                    let note_close_button = document.createElement('span')
                    note_close_button.innerHTML = '<svg t="1670226356192" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2683" width="20" height="20"><path d="M557.2 512l233.4-233.4c12.5-12.5 12.5-32.8 0-45.2s-32.8-12.5-45.2 0L512 466.8 278.6 233.4c-12.5-12.5-32.8-12.5-45.2 0s-12.5 32.8 0 45.2L466.8 512 233.4 745.4c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4L512 557.2l233.4 233.4c6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4c12.5-12.5 12.5-32.8 0-45.2L557.2 512z" p-id="2684"></path></svg>'
                    note_close_button.classList.add('note_close_button')
                    note_close_button.onclick = (event) => {

                        // 点击关闭按钮

                        handleCardCloseClick(note.getAttribute('note_id'))
                    }

                    note_title.appendChild(note_title_span)
                    note_title.appendChild(note_close_button)
                    note.appendChild(note_title)

                    note.classList.add('mini')
                }

            }

            // 样式
            if (j !== 0) {
                if (notes[j].getBoundingClientRect().x < notes[j - 1].getBoundingClientRect().x + notes[j - 1].getBoundingClientRect().width) {
                    notes[j].classList.add('overlay')
                } else {
                    notes[j].classList.remove('overlay')
                }
            }


        }
    }

    // 关闭卡片
    const handleCardCloseClick = (note_id) => {

        console.log('handleCardCloseClick');
        landedOnHomeRef.current = false
        // 修改 URL
        // 只传 basename 下的相对路径（完整 href 在多租户前缀下会被 router 当成再拼一层）
        let new_url = ('/post' + window.location.search).replace('note-id=' + note_id, '')
        // 设置新的 URL
        // window.history.pushState({}, '', new_url)
        navigate(new_url)

        // 记录 URL
        CURRENT_URL = window.location.href

        // 更新 UI
        herfToData()

    }

    // 获取 URL 参数
    // 解析地址里的卡片参数。旧实现把 & 全删掉再按 note-id= 切，任何多余参数（微信转发自带的 from=singlemessage&isappinstalled=0、
    // 调试用的 wxdebug=1）都会粘到最后一个 ID 后面 → 「卡片不存在」。现在用 URLSearchParams，只认 note-id / active-note-id。
    // 返回形状保持不变：url_search_list 首元素是空串（调用方按 length < 3 判断只有一张卡），active_str 是 'active-note-id=<id>' 或空串
    const getUrlSearch = (location_search) => {
        const raw = String(location_search || '')
        const qi = raw.indexOf('?')
        const query = qi > -1 ? raw.slice(qi + 1) : (/^https?:/i.test(raw) ? '' : raw)
        const params = new URLSearchParams(query.split('#')[0])
        const ids = params.getAll('note-id').map((v) => v.trim()).filter(Boolean)
        const active = (params.get('active-note-id') || '').trim()
        return { 'url_search_list': ['', ...ids], 'active_str': active ? 'active-note-id=' + active : '' }
    }

    // 将焦点卡片 ID 写入 URL
    const setUrlActiveNote = (note_id) => {

        // 获取 URL 中的焦点卡片信息
        let getUrlSearch_req = getUrlSearch(window.location.search)
        let active_str = getUrlSearch_req['active_str']

        let new_url_search = window.location.search

        if (active_str === '') {
            // URL 中无焦点卡片

            new_url_search = new_url_search + '&active-note-id=' + note_id

        } else {
            // URL 中有焦点卡片

            // 如果焦点卡片无变化，则不更新
            if (active_str.indexOf(note_id) > -1) {
                return
            }

            new_url_search = new_url_search.replace(active_str, 'active-note-id=' + note_id)
        }


        // 设置 URL
        // window.history.pushState({}, '', window.location.origin + '/post' + new_url_search)
        const newURL = '/post' + new_url_search;
        navigate(newURL)

        // 记录 URL
        CURRENT_URL = publicUrl('/post' + new_url_search)

        // setState({
        //     location: window.location.href
        // })

    }

    // return() {

    if (status) {
        const actions = status === 'loadError'
            ? [{ label: '重试', onClick: () => window.location.reload(), primary: true }]
            : status === 'emptySite'
                ? [{ label: '查看其他站点', href: '/', primary: true }]
                : [{ label: '回到首页', to: '/', primary: true }, { label: '浏览全部笔记', to: '/notes/' }]
        return (
            <div className='status-page'>
                <Nav />
                <main className='status-page-main'>
                    <StatusView kind={status} actions={actions} />
                </main>
            </div>
        )
    }

    if (!HEPTABASE_DATA || cardList.length === 0) {
        return (<div>
            {/* <Nav /> */}
            <div className='notes' style={{
                padding: '1rem'
            }}>
                <Loading />
            </div>
            {/* <Footer /> */}
        </div>)
    } else {

        // console.log(state.activeNote);

        let card_list_dom = []

        //如果屏幕宽度较小，则只显示 1 条笔记
        if (windowWidth < minWidth) {

            // 获取用户关注的笔记进行展示

            let card = null;
            if (cardList.length > 0) {
                card = cardList[cardList.length - 1]

                for (let k = 0; k < cardList.length; k++) {
                    if (cardList[k] && cardList[k]['card'] && cardList[k]['card']['id'] === ACTIVE_NOTE) {
                        card = cardList[k]
                        break;
                    }
                }
            }

            //设置笔记样式
            // left = index*40px; right = index*-40-400
            if (card) {
                let note_style = {
                    left: 0
                }
                card_list_dom.push(<Container style={note_style} key={card['card']['id']} handleHashChange={handleHashChange} handleLinkClick={handleLinkClick} card={card} />)
            }
        } else {
            for (let i = 0; i < cardList.length; i++) {
                let card = cardList[i]

                //设置笔记样式
                // left = index*40px; right = index*-40-400
                if (card && card['card']) {
                    let note_style = {
                        left: i * 40 + 'px',
                        right: -694.8 + (cardList.length - i) * 40 + 'px',
                        flex: '0 0 auto'
                    }

                    let note = <Container style={note_style} key={card['card']['id']} handleHashChange={handleHashChange} handleLinkClick={handleLinkClick} card={card} />
                    card_list_dom.push(note)
                }
            }
        }

        // 设置网页标题
        for (let k = 0; k < cardList.length; k++) {
            if (cardList[k] && cardList[k]['card'] && cardList[k]['card']['id'] === ACTIVE_NOTE) {

                const site = getSiteConfig()
                if (cardList[k]['card']['title'] && cardList[k]['card']['title'] !== 'About') {
                    document.title = cardList[k]['card']['title']
                } else {
                    document.title = (site && site.title) || 'Notes'
                }
                // 社交分享标签跟着焦点卡走（微信在执行完 JS 的 DOM 里取 title / 首图）；规则与服务端注入一致
                const share = cardShareData(cardList[k]['card'], site)
                updateShareMeta({
                    title: document.title,
                    description: share.excerpt || (site && site.description) || document.title,
                    url: publicUrl('/post?note-id=' + ACTIVE_NOTE),
                    image: share.image,
                    imageSquare: share.imageSquare,
                })

                break;
            }
        }

        return (

            // <NextUIProvider>
            <div className='notes_box'>
                <Nav handleShowChatWindow={handleShowChatWindow} discord={windowWidth > minWidth} />


                <div className='flex flex-row' style={{
                    overflowX: 'scroll',
                    overflowY: 'hidden',
                    flex: '1'
                }}>

                    <div onScroll={setCardMiniTitleAndStyle} className='notes' style={{
                        marginRight: showChatWindow && '460px',
                        // borderRight: showChatWindow && '1px solid #d0d7de'
                    }}>

                        {card_list_dom}

                    </div>
                    {showChatWindow && <React.Suspense fallback={null}><WidgetBot
                        server={CONFIG.server}
                        channel={CONFIG.channel}
                        style={{
                            position: 'absolute',
                            right: '0',
                            margin: '10px',
                            width: '440px',
                            height: '91vh'
                        }}
                    /></React.Suspense>}

                </div>

            </div>
            // </NextUIProvider>
        )
    }
    // }

}

export default Post;